import { ClarionSpinner } from '@clarion/ClarionSpinner';
import { useNavigation } from 'react-router';

export function GlobalSpinner() {
  return (
    <div className="fixed top-20 inset-x-0 mx-auto p-2 bg-gray-100 dark:bg-gray-500 w-min shadow-md rounded-full z-50">
      <ClarionSpinner size={24} announce />
    </div>
  );
}

// Displays a global spinner while react-router is loading a route’s code or loader data
export function NavigationSpinner() {
  const { state } = useNavigation();
  return state === 'loading' && <GlobalSpinner />;
}
